var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHouseholdsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3494 21.3233H13.3984C14.503 21.3233 15.3984 20.4279 15.3984 19.3233V12.4428C15.3984 11.8878 15.1678 11.3578 14.7618 10.9795L9.18828 5.78626C8.42021 5.07059 7.22953 5.0706 6.46146 5.78626L0.887928 10.9795C0.481917 11.3578 0.251343 11.8878 0.251343 12.4428V19.3233C0.251343 20.4279 1.14677 21.3233 2.25134 21.3233H5.30036V15.6633H10.3494V21.3233Z",
    fill: "#78C2A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30042 15.6636H10.3494V21.3237H5.30042V15.6636Z",
    fill: "#DAFFF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4158 1.3208C12.4158 0.768516 12.8635 0.320801 13.4158 0.320801H23.8389C24.3912 0.320801 24.8389 0.768516 24.8389 1.3208V21.4224H12.4158V1.3208Z",
    fill: "#DAFFF0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.4917,
    y: 2.89551,
    width: 1.90674,
    height: 1.90674,
    fill: "#78C2A5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.4917,
    y: 8.04785,
    width: 1.90674,
    height: 1.90674,
    fill: "#78C2A5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.7092,
    y: 12.7754,
    width: 1.90674,
    height: 1.90674,
    fill: "#78C2A5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.7092,
    y: 17.5034,
    width: 1.90674,
    height: 1.90674,
    fill: "#78C2A5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 17.4565,
    y: 2.96387,
    width: 1.90674,
    height: 1.90674,
    fill: "#78C2A5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 17.4565,
    y: 8.11621,
    width: 1.90674,
    height: 1.90674,
    fill: "#78C2A5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 17.6741,
    y: 12.8438,
    width: 1.90674,
    height: 1.90674,
    fill: "#78C2A5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 17.6741,
    y: 17.5718,
    width: 1.90674,
    height: 1.90674,
    fill: "#78C2A5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 21.4215,
    y: 2.96387,
    width: 1.90674,
    height: 1.90674,
    fill: "#78C2A5"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 21.4214,
    y: 8.11621,
    width: 1.90674,
    height: 1.90674,
    fill: "#78C2A5"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 21.6389,
    y: 12.8438,
    width: 1.90674,
    height: 1.90674,
    fill: "#78C2A5"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 21.6389,
    y: 17.5718,
    width: 1.90674,
    height: 1.90674,
    fill: "#78C2A5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseholdsIcon);
export default __webpack_public_path__ + "static/media/Households-icon.f1ad78b571b896699c06901febddff74.svg";
export { ForwardRef as ReactComponent };